import { Injectable } from '@angular/core';
import { utils, writeFile } from 'xlsx';

@Injectable({
    providedIn: 'root',
})
export class ExcelService {
    constructor() { }

    static toExportFileName(excelFileName: string): string {
        return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
    }

    public formatExcelCols(json: any) {
        let widthArr = Object.keys(json[0]).map(key => {
            return { width: key?.length <= 8 ? key.length + 5 : key.length + 2 } // plus 5 to account for short object keys
        })
        for (let i = 0; i < json?.length; i++) {
            let value = Object.values(json[i]) as any;
            for (let j = 0; j < value?.length; j++) {
                if (value[j] !== null && value[j]?.length > widthArr[j].width) {
                    widthArr[j].width = value[j]?.length;
                }
            }
        }
        return widthArr
    }

    public async exportToFile(header: any[], data: any[], excelFileName: string) {
        const wb = utils.book_new();
        const ws: any = utils.json_to_sheet([]);

        ws["!cols"] = this.formatExcelCols(data)

        utils.sheet_add_aoa(ws, [header]);
        utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Report');
        writeFile(wb, ExcelService.toExportFileName(excelFileName));
    }
}
